import { render, staticRenderFns } from "./bahanbaku.vue?vue&type=template&id=2209783e"
import script from "./bahanbaku.vue?vue&type=script&lang=js"
export * from "./bahanbaku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports